import { IExternalPRNG } from '@kameleoon/javascript-sdk-core';

export class KameleoonPRNG implements IExternalPRNG {
  public getRandomNumber(): number {
    return Math.random();
  }
}
